import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import {log10} from 'notebook/tables/excess/util/fdlibm';

export default {
  name: 'LOG',
  category: FunctionCategory.MATH,
  shortDescription: 'The logarithm of a number, base ten.',
  description: 'Returns the logarithm of a number base 10.',
  params: [
    {
      name: 'value',
      type: ArgType.positiveNumber,
      description: 'The value for which to calculate the logarithm, base 10.',
    },
  ],
  eval: (value: number): number => log10(value),
} satisfies EvaluablePrimitiveSpreadsheetFunction;
